import { render, staticRenderFns } from "./CancelInvoice.vue?vue&type=template&id=2bb02b39"
import script from "./CancelInvoice.vue?vue&type=script&lang=js"
export * from "./CancelInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports